<template>
    <section>
        <ul id="news">
            <li v-for="n in news" class="screen-transition" @click="select(n.news_id_enc, $event)">
                <div class="created_at" v-if="sabra_access_status!=1">{{ n.date }}</div>
                <div class="news-title">{{ n.title }}</div>
                <img src="/image/icons/next.png">
            </li>
        </ul>
        <div v-if="showButton">
            <a class="button btn btn-dark" role="button" aria-pressed="true" @click="getNews()" style="color: white">{{ characters.load_more }}</a>
        </div>
    </section>
</template>

<script>
    export default {
        name: "news",
        props: ['get_news_number', 'sabra_access_status', 'json_characters'],
        mounted() {
            console.log('news mounted');
            console.log('sabra_access_status: '+this.sabra_access_status);
            axios
                .default
                .get('/news/list/' + this.news.length)
                .then(response => {
                    if(response.data.length<this.get_news_number) {
                        this.showButton = false;
                    }
                    this.news = response.data;
                });
            this.characters = JSON.parse(this.json_characters);
        },
        data: function () {
            return {
                news: [],
                showButton: true,
                characters: Object,
            }
        },
        methods: {
            select: function (s, event) {
                console.log(s);
                if (s) {
                    const id = String(s);
                    location.href = `/news/detail/${id}`;
                }
            },
            getNews: function () {
                axios.default
                    .get('/news/list/' + this.news.length)
                    .then(response => {
                        if(response.data.length<this.get_news_number) {
                            this.showButton = false;
                        }
                        this.news = this.news.concat(response.data);
                    });
            }
        }
    }
</script>

<style scoped>

</style>
